import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { types } from "../settingMenu";
import styles from "../Camera.module.css";
import { CameraIcon, VideoIcon } from "../../../../components/Icons/Icons";
import { CameraMoveOutLine } from "../../../../components/Icons/Setting/CameraMoveOutLine";
import { LicensePlatesOutLine } from "../../../../components/Icons/Setting/LicensePlatesOutLine";
import { FireDetectOutLine } from "../../../../components/Icons/Setting/FireDetectOutLine";
import { FaceDetectOutLine } from "../../../../components/Icons/Setting/FaceDetectOutLine";
import { MotionDetectOutLine } from "../../../../components/Icons/Setting/MotionDetectOutLine";
import { ObjectDetectOutLine } from "../../../../components/Icons/Setting/ObjectDetectOutLine";
import { BellIcon } from "../../../../components/Icons/NotificationSetting";
import { NotificationIcon } from "../../../../components/Icons/SideBar/NotificationIcon";
import { useTranslation } from "react-i18next";
import { CarPark } from "../../../../components/Icons/Setting/CarPark";

const cx = classNames.bind(styles);
const SideBar = ({ type, onChange, listServiceAI, typeCamera }) => {
  const [listSideBar, setListSideBar] = useState([])
  const { t } = useTranslation()

  const onChanges = (data) => {
    if (onChange) {
      onChange(data);
    }
  };
  const addIconsService = (listService) => {
    const itemSideBars = listService?.map(item => {
      switch (item?.key) {
        case "2":
          return {
            ...item,
            icon: <CameraIcon />
          }
        case "3":
          return {
            ...item,
            icon: <VideoIcon />
          }
        case "4":
          return {
            ...item,
            icon: <NotificationIcon color={"rgba(0,0,0,0.4)"} />
          }
        case "20230222000000000001":
          return {
            ...item,
            icon: <MotionDetectOutLine color="rgba(0,0,0,0.4)" />
          }
        case "20230222000000000004":
          return {
            ...item,
            icon: <ObjectDetectOutLine color="rgba(0,0,0,0.4)" />
          }
        case "20230222000000000002":
          return {
            ...item,
            icon: <FaceDetectOutLine color="rgba(0,0,0,0.4)" />
          }
        case "20230222000000000005":
          return {
            ...item,
            icon: <CameraMoveOutLine color="rgba(0,0,0,0.4)" />
          }
        case "20230222000000000006":
          return {
            ...item,
            icon: <LicensePlatesOutLine color="rgba(0,0,0,0.4)" />
          }
        case "20230222000000000007":
          return {
            ...item,
            icon: <FireDetectOutLine color="rgba(0,0,0,0.4)" />
          }
        case "20230222000000000008":
          return {
            ...item,
            icon: <CarPark color="rgba(0,0,0,0.4)" />
          }
        default:
          return {
            ...item,
            icon: ""
          }
      }
    })
    return itemSideBars;

  }
  useEffect(() => {
    const listAi = listServiceAI?.filter(ai => ai?.key !== '20230222000000000000')
    const listNav = addIconsService(types.concat([...listAi, {
      name: t("header.setupNotification"),
      key: "4"
    },]));
    setListSideBar(listNav)
    // setListSideBar(types.concat(listAi))
    // eslint-disable-next-line
  }, [listServiceAI, types])
  return (
    <div className={cx("sidebar")}>
      <ul className={cx("list-menu")}>
        {listSideBar.length > 0 && listSideBar.map((item) => {
          if (item.key === "20230222000000000007") {
            return (
              // typeCamera === "HIK" ? <></> : 
              <li
                onClick={(e) => onChanges(item.key)}
                key={item.key}
                className={cx("item-menu", type === item.key ? "active" : "")}
              >
                <div className={cx('item-menu_nav')}>
                  <span>{item?.icon}</span>
                  {item.name}
                </div>
              </li>
            );
          }
          else {
            return (
              <li
                onClick={(e) => onChanges(item.key)}
                key={item.key}
                className={cx("item-menu", type === item.key ? "active" : "")}
              >
                <div className={cx('item-menu_nav')}>
                  <span>{item?.icon}</span>
                  {item.name}</div>
              </li>
            );
          }
        })}
      </ul>
    </div>
  );
};

export default SideBar;
